/**
 * セクショングループ管理ホームページ専用i18n定数
 */

export const SECTION_GROUP_HOME_I18N = {
  // ページタイトル
  title: {
    dashboard: $localize`:@@sectionGroupAdmin.home.title.dashboard:ダッシュボード`,
    dataUsage: $localize`:@@sectionGroupAdmin.home.title.dataUsage:データ使用量`,
    importantNotices: $localize`:@@sectionGroupAdmin.home.title.importantNotices:重要なお知らせ`,
  },
  // チャートラベル
  chart: {
    xAxisMonth: $localize`:@@sectionGroupAdmin.home.chart.xAxisMonth:月`,
    yAxisDataUsage: $localize`:@@sectionGroupAdmin.home.chart.yAxisDataUsage:データ使用量 (GB)`,
    yAxisUsers: $localize`:@@sectionGroupAdmin.home.chart.yAxisUsers:ユーザー数（名）`,
  },
  // チャートタイトル
  chartTitle: {
    sectionRanking: $localize`:@@sectionGroupAdmin.home.chartTitle.sectionRanking:セクション別データ使用量`,
    userTrend: $localize`:@@sectionGroupAdmin.home.chartTitle.userTrend:セクション別ユーザー数推移`,
  },
  // ラベル
  label: {
    monthOverMonth: $localize`:@@sectionGroupAdmin.home.label.monthOverMonth:前月比`,
    remaining: $localize`:@@sectionGroupAdmin.home.label.remaining:残り`,
    sectionCount: $localize`:@@sectionGroupAdmin.home.label.sectionCount:セクション数`,
    totalStaff: $localize`:@@sectionGroupAdmin.home.label.totalStaff:総スタッフ数`,
    totalContributors: $localize`:@@sectionGroupAdmin.home.label.totalContributors:総多職種スタッフ数`,
    totalUsers: $localize`:@@sectionGroupAdmin.home.label.totalUsers:総ユーザー数`,
    currentUsage: $localize`:@@sectionGroupAdmin.home.label.currentUsage:今月の使用量`,
  },
} as const;

export type SectionGroupHomeI18n = typeof SECTION_GROUP_HOME_I18N;
